// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=email],input[type=password],input[type=search],input[type=tel],input[type=text],input[type=url],textarea{border:0 solid #ccc!important}", ""]);
// Exports
module.exports = exports;
